

import BasicInfo from './BasicInfo';
import Intro from './Intro';
export default function AboutMe(){
    return(
        <div>
            <Intro/>
            <BasicInfo/>
        </div>
    )
}